import {createReducer, on} from '@ngrx/store';
import * as ProjectActions from './project.actions';
import {ProjectDTO} from '../dto/project';

export interface ProjectState {
  projects: ProjectDTO[];
  exploreProjects: ProjectDTO[];
  selectedProject: ProjectDTO | null;
  error: any;
  loading: boolean;
}

export const initialState: ProjectState = {
  projects: [],
  exploreProjects: [],
  selectedProject: null,
  error: null,
  loading: false,
};

export const projectReducer = createReducer(
  initialState,
  on(ProjectActions.loadProjects, (state) => ({
    ...state,
    loading: true,
  })),
  on(ProjectActions.loadProjectsSuccess, (state, {projects}) => ({
    ...state,
    projects,
    loading: false,
  })),
  on(ProjectActions.loadProjectsFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false,
  })),
  on(ProjectActions.loadExploreProjects, (state) => ({
    ...state,
    loading: true,
  })),
  on(ProjectActions.loadExploreProjectsSuccess, (state, {projects}) => ({
    ...state,
    exploreProjects: projects,
    loading: false,
  })),
  on(ProjectActions.loadExploreProjectsFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false,
  })),
  on(ProjectActions.createProjectSuccess, (state, {project}) => ({
    ...state,
    projects: [...state.projects, project],
  })),
  on(ProjectActions.updateProjectSuccess, (state, {project}) => ({
    ...state,
    projects: state.projects.map((p) => (p.id === project.id ? project : p)),
  })),
  on(ProjectActions.deleteProjectSuccess, (state, {id}) => ({
    ...state,
    projects: state.projects.filter((project) => project.id !== id),
  })),
  on(ProjectActions.retrieveProject, (state, {}) => ({
    ...state,
    selectedProject: null,
  })),
  on(ProjectActions.retrieveProjectSuccess, (state, {project}) => ({
    ...state,
    selectedProject: project,
  })),
  on(ProjectActions.createProjectFailure, ProjectActions.updateProjectFailure, ProjectActions.deleteProjectFailure, ProjectActions.retrieveProjectFailure, ProjectActions.loadProjectsFailure, (state, {error}) => ({
    ...state,
    error,
  }))
);
